/* eslint-disable react/jsx-no-bind */
import React, { useState, useEffect } from 'react';
import { compose, withHandlers } from 'recompose';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Grid } from '@material-ui/core';
import {
  PSRS_ACTIONS,
  getPsrs,
  getPsrsAffiliation,
  setPsrIndex,
  savePsrsAffiliation,
  setEmptyPsrAffiliation,
  changeSequence,
  deletePsrAffiliation,
  getAffiliationsHistory,
  setSelectedPsr
} from 'actions/protocols/psrs';
import {
  CanUserAccessPSR,
  CanUserViewPSRAffiliations,
  CanUserViewPSRDetails,
  CanUserEditPSRAffiliations,
  CanUserEditPSRDetails
} from 'appconstants/Permission';
import { getVersions } from 'actions/protocols/version';
import * as selectors from 'selectors';
import { withAppContext } from '@ctsu/loader';
import { RenderControl, RenderDelay, RenderElement } from 'components/RenderHelpers';
import _ from 'lodash';
import { bindLogger } from 'helpers/BindLogger';
import { httpStatusEnum } from 'appconstants';
import { openSnackbar } from 'helpers/Notifier';
import RSSDialog from 'containers/modal/components/RSSDialog';
import { PSRInfo, PSRDetails, SpecialRequirement } from './components';
import { AffiliationsHistory } from './components/AffiliationsHistory';

const lSelector = selectors.createLoadingSelector([PSRS_ACTIONS.GET_PSRS]);
const eSelector = selectors.createErrorMessageSelector([PSRS_ACTIONS.GET_PSRS]);
const lAffSelector = selectors.createLoadingSelector([PSRS_ACTIONS.GET_PSRS_AFFILIATION]);
const eAffSelector = selectors.createErrorMessageSelector([PSRS_ACTIONS.GET_PSRS_AFFILIATION]);


const PSRS = ({
  context,
  protocolNumber,
  psrIndex,
  psrInfo,
  psrSplReqAffi,
  versions,
  onGetPsr,
  onSetPsrIndex,
  onSetPsrSelected,
  onGetVersions,
  onSavePsrAffiliation,
  onChangeSequence,
  isPSRloading,
  isPSRerror,
  isAffloading,
  isAfferror,
  isLoadingPrtDetails,
  iserrorPrtDetails,
  onGetPsrsAffiliation,
  getSplReqAndAffiliation,
  onSetPsrsEmptyAffiliation,
  onDeleteAffiliation,
  onGetAffiliationsHistory,
  historyData,
  selectedPsr,
  onSetSelectedPsr
}) => {
  const [highlightObj, sethighlightObj] = useState({ highlightRow: 0 });
  // const [esysStatus, setEsysStatus] = useState(null);
  const [pageData, setPageData] = useState([]);
  const [hideAffiliationOnEdit, setHideAffiliationOnEdit] = useState(false);
  const [openModal, setOpenModal] = useState(false);

  const psrData = psrInfo.data || [];
  // const psrSelectedData = esysStatus === '' ? pageData : _.filter(pageData, { esysStatus: esysStatus || 'ACTIVE' });

  const psrID = selectedPsr?.psrId;

  const minPsrId = psrData[0] && psrData[0].psrId;
  const maxPsrId = psrData[psrData.length - 1] && psrData[psrData.length - 1].psrId;

  useEffect(() => {
    if (!_.isEmpty(protocolNumber)) {
      bindLogger(onGetPsr, context)(protocolNumber);
      bindLogger(onGetVersions, context)(protocolNumber);
    }
  }, [protocolNumber, onGetPsr, onGetVersions, onSetPsrIndex, context]);

  useEffect(() => {
    if (!_.isEmpty(protocolNumber) && !_.isNil(psrID)) {
      bindLogger(onGetPsrsAffiliation, context)(protocolNumber, psrID);
    } else {
      onSetPsrsEmptyAffiliation();
    }
  }, [psrID, onGetPsrsAffiliation, protocolNumber, context, onSetPsrsEmptyAffiliation]);

  const onLoadHistoryData = () => {
    if (psrID != null) {
      bindLogger(onGetAffiliationsHistory, context)(psrID);
    }
  }

  const onLoad = (response) => {
    onSetPsrIndex(0);
    setPageData(response.data);
    sethighlightObj({ highlightRow: 0 });
    onSetSelectedPsr(response?.data[0]);
  }

  const clickedRow = (row, index) => {
    if (index >= 0) {
      onSetPsrIndex(index);
      sethighlightObj({ highlightRow: index });
      onSetSelectedPsr(row);
    }
  }

  const setHighlighted = (filfield) => {
    sethighlightObj({ highlightRow: 0 });
    onSetPsrIndex(0);
  }

  const handleHistClick = () => {
    onLoadHistoryData();
    setOpenModal(true);
  }

  return (
    <RenderControl
      isLoading={isLoadingPrtDetails}
      iserror={iserrorPrtDetails}
      compName="PSR Information"
      permission={CanUserAccessPSR()}
    >
    <RSSDialog
        title="PSR Affiliations & Verifications Change History"
        show={openModal}
        onClose={() => setOpenModal(false)}
    >
        {openModal ? <AffiliationsHistory historyData={historyData} tagId="affiliationsHistory" /> : null}
    </RSSDialog>
      <Grid container justify="center" spacing={4}>
        <Grid item xs={12}>
          <RenderControl
            isLoading={isPSRloading}
            iserror={isPSRerror}
            compName="PSR Information"
            permission={CanUserAccessPSR()}
          >
            <PSRInfo
              minPsrId={minPsrId}
              maxPsrId={maxPsrId}
              highlightObj={highlightObj}
              setHighlighted={setHighlighted}
              data={psrData}
              onRowClicked={clickedRow}
              changeSequence={onChangeSequence}
              onDataLoad={onLoad}
            />
          </RenderControl>
        </Grid>
      </Grid>
      <div className="related-border-top related-border-active">
        <Grid container justify="center" spacing={4}>
          <Grid item xs={6}>
            <RenderControl
              isLoading={isPSRloading}
              iserror={isPSRerror}
              compName="PSR Additional Details"
              permission={CanUserViewPSRDetails()}
            >
              <RenderDelay delayTimeInSec={1} elValue={psrIndex}>
                <PSRDetails
                  data={pageData[psrIndex]}
                  psrIndex={psrIndex}
                  versions={versions}
                  context={context}
                  deleteAffiliation={onDeleteAffiliation}
                  editMode={CanUserEditPSRDetails()}
                  editAff={CanUserEditPSRAffiliations()}
                  setHideAffiliationOnEdit={setHideAffiliationOnEdit}
                />
              </RenderDelay>
            </RenderControl>
          </Grid>
          <Grid item xs={6}>
            <RenderElement access={!hideAffiliationOnEdit}>
              <RenderControl
                isLoading={isAffloading}
                iserror={isAfferror}
                compName="Affiliations & Verifications"
                permission={CanUserViewPSRAffiliations()}
              >
                <RenderDelay delayTimeInSec={1} elValue={psrIndex}>
                  <SpecialRequirement
                    tagId="editPsraffiandverifications"
                    psrData={pageData[psrIndex]}
                    psrSplReqAffi={psrSplReqAffi && psrSplReqAffi.data}
                    psrId={psrID}
                    deleteAffiliation={onDeleteAffiliation}
                    onSave={onSavePsrAffiliation}
                    editMode={CanUserEditPSRAffiliations()}
                    handleHistClick={handleHistClick}
                  />
                </RenderDelay>
              </RenderControl>
            </RenderElement>
          </Grid>
        </Grid>
      </div>
    </RenderControl>
  );
};

const mapStateToProps = state => ({
  protocolNumber: selectors.ProtocolNumSelector(state),
  protocolId: selectors.ProtocolIdSelector(state),
  psrIndex: state.psrs.psrIndex,
  psrInfo: state.psrs.psrInfo,
  psrSplReqAffi: state.psrs.psrSplReqAffi,
  versions: state.versions.localVersions,
  historyData: state.psrs.affiliationsHistory,
  selectedPsr: state.psrs.selectedPsr,
  isPSRloading: lSelector(state),
  isPSRerror: eSelector(state),
  isAffloading: lAffSelector(state),
  isAfferror: eAffSelector(state),
  isLoadingPrtDetails: selectors.lSelectorGetProtDetails(state),
  iserrorPrtDetails: selectors.eSelectorGetProtDetails(state)
});

const withConnectState = connect(mapStateToProps,
  dispatch => bindActionCreators(
    {
      onGetPsr: getPsrs,
      onGetPsrsAffiliation: getPsrsAffiliation,
      onSetPsrsEmptyAffiliation: setEmptyPsrAffiliation,
      onSetPsrIndex: setPsrIndex,
      onGetVersions: getVersions,
      onSavePsrAffiliation: savePsrsAffiliation,
      onChangeSequence: changeSequence,
      onDeletePsrAffiliation: deletePsrAffiliation,
      onGetAffiliationsHistory: getAffiliationsHistory,
      onSetSelectedPsr: setSelectedPsr
    },
    dispatch
  ));

const PSRSContainer = compose(
  withConnectState,
  withAppContext,
  withHandlers({
    getSplReqAndAffiliation: props => psrID => {
      const { context, onGetPsrsAffiliation, protocolNumber } = props;
      bindLogger(onGetPsrsAffiliation, context)(protocolNumber, psrID);
    },
    onSavePsrAffiliation: props => (postBody, psrId) => {
      const { onSavePsrAffiliation, context, protocolId } = props;
      return bindLogger(onSavePsrAffiliation, context)(protocolId, postBody, psrId);
    },
    onChangeSequence: props => (psrID, direction) => {
      const { onChangeSequence, context, protocolId } = props;
      return bindLogger(onChangeSequence, context)(protocolId, psrID, direction);
    },
    onDeleteAffiliation: props => (affilId, psrId) => {
      const { onDeletePsrAffiliation, context, protocolId } = props;
      bindLogger(onDeletePsrAffiliation, context)(protocolId, psrId, affilId).subscribe(resp => {
        if (resp.status === httpStatusEnum.SUCCESS) {
          openSnackbar({
            message: `Deleted PSR Affiliation successfully.`,
            variant: 'success',
            name: 'study_agents_cancel'
          });
        }
      });
    }

  })
)(PSRS);

export default PSRSContainer;
